import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import { useOpenableControls } from '../../../../../../generic-hooks'
import { RedPointsBenefitDialog } from '../../../../../../redpoints'
import { ProductHeadGenericLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLabel'
import { type ProductHeadLabel } from '../../ProductHeadLabelsTypes'

export const ProductHeadRedPointsLabel: FC<{ label: ProductHeadLabel }> = ({
  label,
}) => {
  const multiplier = label.redPointsMultiplierSpecific?.multiplier
  const modalControls = useOpenableControls()

  if (!multiplier) {
    return null
  }

  return (
    <>
      <ProductHeadGenericLabel
        className="border-light-primary-strong bg-light-primary-medium text-dark-primary-max"
        data-qa-id="form-red-points-modal-button"
        onClick={modalControls.handleOpen}
      >
        <>
          {multiplier}
          {'x '}
          <FormattedMessage id="general.label.redPoints" />
          <IconInfo className="ml-2 size-4" />
        </>
      </ProductHeadGenericLabel>
      <RedPointsBenefitDialog
        isOpen={modalControls.isOpen}
        onClose={modalControls.handleClose}
      />
    </>
  )
}
